import React from 'react';
import { Backdrop, CircularProgress } from '@mui/material';
import { useSelector } from 'react-redux';

import { selectLoading } from '../../services/controllers/common/CommonSelector';

interface LoadingWrapProps {
  open?: boolean;
}

const LoadingWrap: React.FC<LoadingWrapProps> = ({ open = false }): React.ReactElement | null => {
  const loading = useSelector(selectLoading);

  return open ? (
    <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={open || loading}>
      <CircularProgress color="inherit" size={60} />
    </Backdrop>
  ) : null;
};

export default LoadingWrap;
